// # Blender v2.80 (sub 75) OBJ File: ''
// o kanitz
export default [[-0.230000, -4.470000], [-0.230000, -1.620000], [0.000000, -4.470000], [0.000000, -1.250000]];